﻿window.stickyHeader = (function () {
    function init() {
        var scrollEnabled = true

        if ($('#smartbanner').length) {
            $('.sb-close').on('click', function () {
                scrollEnabled = false

                $('.header-top').css({ 'position': 'fixed', 'top': '0' })
            })

            var headerOffsetTop = $('.header-top').offset().top

            $(window).on('scroll', function () {
                var windowScroll = $(document).scrollTop()

                if (scrollEnabled) {
                    if (windowScroll > headerOffsetTop)
                        $('.header-top').css({ 'position': 'fixed', 'top': '0' })
                    else
                        $('.header-top').css({ 'position': 'absolute', 'top': 'auto' })
                }
            })
        }
    }

    return {
        init
    }
}())

$(window).on("load", function () {
    window.stickyHeader.init()
})
